<template>
	
							  
							  <el-table-column  prop='imgurl' :label="title" > <template  slot-scope="scope">
							  <span class="el-avatar el-avatar--circle imgages" style="height: 30px;width: 30px;">
								  <el-image v-if="!isAvatarUrl"  :preview-src-list="[$domain+scope.row[column]]" :src="$domain+scope.row[column]" style="object-fit: cover;">  </el-image>
								   <el-image  v-else :preview-src-list="[scope.row[column]]" :src="scope.row[column]" style="object-fit: cover;">  </el-image>
							  </span>
							  <!-- <el-image 
							      style="width: 100%; height: 23px"
							      :preview-src-list="[$domain+scope.row.imgurl]" :src="$domain+scope.row.imgurl">
							    </el-image> -->
							  						  </template></el-table-column>
</template>

<script>
	export default {
			      props: {
			      	title: {
			      		type: String,
			      		default: '图片'
			      	},
					isAvatarUrl: {
						type: Boolean,
						default: false
					},
					column: {
						type: String,
						default: 'imgurl'
					},
			      },  
	  data() {
	    return {
			pageName:''
				 }
	  },
			
	  methods: {
				ordersClick(e){
				 this.$axios.put(`/api/${this.pageName}/Put${this.pageName}Orders?id=${e.id}&orders=${e.orders}`).then(e => {
				 	 this.$message.success('操作成功到同步服务器');
				   });
				},
			},
			mounted() {
			this.pageName= this.$route.path.replace('/','')
			},
	}
</script>

<style>
	.imgages < div{
	   color: red;
	}
</style>
